module.exports = __webpack_public_path__ + "icon-email-big.png?0899756e164890d056bda2f87ecbcfb6";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-email-big.png
// module id = 588
// module chunks = 26